/* KLSH Mega Menu helpers
   - Cards carousel arrows
   - Close mega menu on scroll
   - Theme Editor safe re-init
*/

(() => {
  const HEADER_SELECTOR = '.section-header';
  const CAROUSEL_SELECTOR = '[data-klsh-mega-carousel]';
  const DESIGN_MODE = typeof Shopify !== 'undefined' && Shopify.designMode;

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.klshMegaInit === 'true') return;

    const viewport = carousel.querySelector('.mega-menu__cards-viewport');
    const prevBtn = carousel.querySelector('[data-klsh-prev]');
    const nextBtn = carousel.querySelector('[data-klsh-next]');

    if (!viewport || !prevBtn || !nextBtn) return;

    const updateButtons = () => {
      const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
      const atStart = viewport.scrollLeft <= 1;
      const atEnd = viewport.scrollLeft >= maxScrollLeft - 1;

      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    };

    const scrollByPage = (direction) => {
      const amount = Math.max(200, Math.floor(viewport.clientWidth * 0.9));
      viewport.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };

    const keepMenuOpenDuringCarouselInteraction = () => {
    const details = carousel.closest('details.mega-menu');
    const headerWrapper = document.querySelector('.header-wrapper');

    if (details) {
      details.dataset.klshCarouselInteracting = 'true';

      window.setTimeout(() => {
        delete details.dataset.klshCarouselInteracting;
      }, 700);
    }

    if (headerWrapper) {
      headerWrapper.preventHide = true;

      window.setTimeout(() => {
        headerWrapper.preventHide = false;
      }, 700);
    }
  };

  const handleArrowClick = (event, direction) => {
    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    keepMenuOpenDuringCarouselInteraction();
    scrollByPage(direction);
  };

  prevBtn.addEventListener('click', (event) => handleArrowClick(event, -1));
  nextBtn.addEventListener('click', (event) => handleArrowClick(event, 1));

  prevBtn.addEventListener('mousedown', (event) => {
    event.preventDefault();
    event.stopPropagation();
  });

  nextBtn.addEventListener('mousedown', (event) => {
    event.preventDefault();
    event.stopPropagation();
  });

  prevBtn.addEventListener('touchstart', (event) => {
    event.stopPropagation();
  }, { passive: true });

  nextBtn.addEventListener('touchstart', (event) => {
    event.stopPropagation();
}, { passive: true });

    viewport.addEventListener(
      'scroll',
      () => {
        window.requestAnimationFrame(updateButtons);
      },
      { passive: true }
    );

    const details = carousel.closest('details');
    if (details) {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        window.setTimeout(updateButtons, 60);
      });
    }

    const onResize = () => window.requestAnimationFrame(updateButtons);
    window.addEventListener('resize', onResize);

    window.setTimeout(updateButtons, 0);
    carousel.dataset.klshMegaInit = 'true';
  }

  function closeMegaMenus(header) {
    if (!header) return;
    header.querySelectorAll('header-menu details.mega-menu[open]').forEach((details) => {
      details.removeAttribute('open');
    });
  }

  function initCloseOnScroll(header) {
    if (!header || DESIGN_MODE) return;
    if (header.dataset.klshMegaScrollInit === 'true') return;

    let lastOpenAt = 0;
    const GRACE_MS = 800;
    const MIN_SCROLL_PX = 40;

    header.querySelectorAll('details.mega-menu').forEach((details) => {
      if (details.dataset.klshMegaToggleInit === 'true') return;

      details.addEventListener('toggle', () => {
        if (details.open) lastOpenAt = Date.now();
      });

      details.dataset.klshMegaToggleInit = 'true';
    });

    let lastY = window.scrollY;
    let rafPending = false;

    const onScroll = () => {
      if (rafPending) return;
      rafPending = true;

      window.requestAnimationFrame(() => {
        const now = Date.now();
        const y = window.scrollY;
        const dy = Math.abs(y - lastY);
        lastY = y;

        if (now - lastOpenAt < GRACE_MS) {
          rafPending = false;
          return;
        }

        if (dy < MIN_SCROLL_PX) {
          rafPending = false;
          return;
        }

        const interactingCarousel = header.querySelector('details.mega-menu[open][data-klsh-carousel-interacting="true"]');

        if (interactingCarousel) {
          rafPending = false;
          return;
        }

        closeMegaMenus(header);
        rafPending = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    header.dataset.klshMegaScrollInit = 'true';
  }

  function init(root = document) {
    root.querySelectorAll(CAROUSEL_SELECTOR).forEach(initCarousel);

    const header =
      root.matches && root.matches(HEADER_SELECTOR)
        ? root
        : root.querySelector
          ? root.querySelector(HEADER_SELECTOR)
          : document.querySelector(HEADER_SELECTOR);

    if (header) {
      initCloseOnScroll(header);
    }
  }

  function initEditorHooks() {
    if (!DESIGN_MODE) return;
    if (document.documentElement.dataset.klshMegaEditorInit === 'true') return;

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });

    document.addEventListener('shopify:section:select', (event) => {
      init(event.target);
    });

    document.addEventListener('shopify:block:select', () => {
      const header = document.querySelector(HEADER_SELECTOR);
      if (!header) return;
      window.requestAnimationFrame(() => {
        header.querySelectorAll('[data-klsh-mega-carousel]').forEach((carousel) => {
          const viewport = carousel.querySelector('.mega-menu__cards-viewport');
          const prevBtn = carousel.querySelector('[data-klsh-prev]');
          const nextBtn = carousel.querySelector('[data-klsh-next]');
          if (!viewport || !prevBtn || !nextBtn) return;

          const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
          prevBtn.disabled = viewport.scrollLeft <= 1;
          nextBtn.disabled = viewport.scrollLeft >= maxScrollLeft - 1;
        });
      });
    });

    document.documentElement.dataset.klshMegaEditorInit = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      initEditorHooks();
    });
  } else {
    init();
    initEditorHooks();
  }
})();